var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.643 2.87H6.74a3.784 3.784 0 0 0-3.784 3.784v8.903A3.784 3.784 0 0 0 6.74 19.34h8.903a3.784 3.784 0 0 0 3.783-3.783V6.654a3.784 3.784 0 0 0-3.783-3.784Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.74 14.489 1.002 1.068 1.67-1.78M6.74 7.366l1.002 1.068 1.67-1.78",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.081 7.545h3.561M12.081 14.666h3.561",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round"
  })));
};
export default SvgList;